import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\AddPDFToEnvelopeController::__invoke
* @see app/Http/Controllers/ElectronicSignature/AddPDFToEnvelopeController.php
* @route '/api/electronic-signature/add-to-envelope'
*/
const AddPDFToEnvelopeController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPDFToEnvelopeController.url(options),
    method: 'post',
})

AddPDFToEnvelopeController.definition = {
    methods: ["post"],
    url: '/api/electronic-signature/add-to-envelope',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\AddPDFToEnvelopeController::__invoke
* @see app/Http/Controllers/ElectronicSignature/AddPDFToEnvelopeController.php
* @route '/api/electronic-signature/add-to-envelope'
*/
AddPDFToEnvelopeController.url = (options?: RouteQueryOptions) => {
    return AddPDFToEnvelopeController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\AddPDFToEnvelopeController::__invoke
* @see app/Http/Controllers/ElectronicSignature/AddPDFToEnvelopeController.php
* @route '/api/electronic-signature/add-to-envelope'
*/
AddPDFToEnvelopeController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPDFToEnvelopeController.url(options),
    method: 'post',
})

export default AddPDFToEnvelopeController